import { PluginKey } from "@tiptap/pm/state";

/**
 * The ProseMirror node name for an Ask Spotlight variable pill. Referenced by Tiptap's command and schema
 * type maps as well as by the extension itself, so it is a constant rather than a repeated string literal.
 */
export const VARIABLE_MENTION_NODE_NAME = "variableMention";

/** The character that opens the variable suggestion. */
export const VARIABLE_MENTION_SUGGESTION_CHAR = "@";

/**
 * The suggestion plugin's own key. Tiptap's `Suggestion` defaults to one shared key, which would collide with any
 * other suggestion (e.g. an emoji picker) registered on the same editor.
 */
export const VARIABLE_MENTION_SUGGESTION_PLUGIN_KEY = new PluginKey("variableMentionSuggestion");

/**
 * The marker attribute identifying a variable mention's `<span>` in serialised HTML. Present but empty - it
 * exists purely so `parseHTML` can match the element.
 */
export const VARIABLE_MENTION_DATA_ATTRIBUTE = "data-variable-mention";

/**
 * The attribute carrying the serialised variable token. It is the single source of truth for a mention's
 * attributes in HTML: the individual attributes are not rendered, and parsing re-derives them all from here,
 * so a mention cannot be half-described by an edited or truncated HTML fragment.
 */
export const VARIABLE_MENTION_TOKEN_ATTRIBUTE = "data-token";
